import React from 'react';
import classNames from 'classnames';
import { IErrorMessage } from './ErrorMessage.types';

export const ErrorMessage: React.FC<IErrorMessage> = ({ error, className }) => {
  const message = (error as { message?: string })?.message || 'Unknown error';
  return <div className={classNames('error-text', className)}>Something went wrong: {message}</div>;
};
